import {includes} from 'ramda'
import {Middleware} from 'redux'

// eslint-disable-next-line @vio/custom-rules/prefer-usebrand-hook
import {getBrand} from '@vio/core/src/_web/brand/modules/selectors'
import {userHasJustAuthenticated} from '@vio/core/src/auth/modules/actions'
import {getPreAuthContext} from '@vio/core/src/auth/services'
import {SourceComponentType} from '@vio/core/src/auth/types/Auth'
import {resolveCapabilities} from '@vio/core/src/brand/capabilities/resolveCapabilities'

import {showMarketingNotificationPopup} from '../../modules/marketingNotifications/slice'

const marketingNotificationsMiddleware: Middleware =
  store => next => action => {
    if (action?.type === userHasJustAuthenticated.type) {
      const brand = getBrand(store.getState())
      const {retention} = resolveCapabilities(brand.capabilities, undefined, {
        skipClientOnly: true
      })

      if (!retention.hasMarketingNotifications) {
        return next(action)
      }

      // Runs a page load after the attempt ended, which is why the record is
      // stamped rather than deleted.
      const sourceComponent = getPreAuthContext()?.sourceComponent

      if (
        includes(sourceComponent, [
          SourceComponentType.Header,
          SourceComponentType.Login,
          SourceComponentType.AccountSideBar,
          SourceComponentType.PriceWatch,
          SourceComponentType.UnlockOverlay,
          SourceComponentType.GoogleOneTap
        ])
      ) {
        next(showMarketingNotificationPopup())
      }

      return next(action)
    }

    return next(action)
  }

export default marketingNotificationsMiddleware
